import { render } from "./ResultTab.vue?vue&type=template&id=312c3b2a"
import script from "./ResultTab.vue?vue&type=script&lang=js"
export * from "./ResultTab.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__